var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavFloorplan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.5C3.1 2.5 2 3.6 2 5V19C2 20.9 3.6 22.5 5.5 22.5H21C21.6 22.5 22 22.1 22 21.5V4.5C22 3.9 21.6 3.5 21 3.5H5.5C5.1 3.5 4.8 3.6 4.5 3.7V2.5ZM4.5 5.5H20V20.5H5.5C4.7 20.5 4 19.8 4 19C4 18.2 4.7 17.5 5.5 17.5H6V5.5H4.5ZM8 6.5H18V18.5H16V15.5H14V18.5H12V10.5H8V6.5ZM8 12.5H10V18.5H8V12.5ZM14 6.5V11.5H16V6.5H14ZM16 13.5H18V15.5H16V13.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavFloorplan);
export default __webpack_public_path__ + "static/media/nav_floorplan.1165c794bc1746773805c96ad7e3eb83.svg";
export { ForwardRef as ReactComponent };